<template>
  <section v-if="exhibitions && exhibitions.length">
    <h2 class="heading-4" v-html="title"></h2>
    <ul v-if="exhibitions.length" :class="$style.list">
      <li v-for="(exhibition, key) in exhibitions" :key="key" class="space-22-27-above">
        <router-link
          :to="{
            name: 'ExhibitionsPost',
            params: { slug: exhibition.slug },
          }"
          :ga4-event="
            JSON.stringify({
              click_type: 'title',
              component: 'ExhibitionsOnView',
              content_group: 'exhibition',
              gtm_tag: 'link',
              link_text: `${exhibition.title}`,
              link_url: `${exhibition.slug}`,
            })
          "
          @click="
            $emit('close');
            checkIsSamePath(exhibition.slug, emit);
          "
          @keydown.enter="
            $emit('close');
            checkIsSamePath(exhibition.slug, emit, $event);
          "
          v-html="exhibition.title"
        >
        </router-link>
        <span :class="$style.label" v-html="format(exhibition.dates)"></span>
      </li>
    </ul>
    <router-link
      :class="[$style.link, 'more-link']"
      :to="{ name: 'ExhibitionsPage' }"
      :ga4-event="
        JSON.stringify({
          click_type: 'link',
          component: 'ExhibitionsOnView',
          content_group: 'exhibition',
          gtm_tag: 'link',
          link_text: `${link}`,
          link_url: '/exhibitions',
        })
      "
      @click="
        $emit('close');
        checkIsSamePath('/exhibitions', emit);
      "
      @keydown.enter="
        $emit('close');
        checkIsSamePath('/exhibitions', emit, $event);
      "
    >
      {{ link }}
    </router-link>
  </section>
</template>

<script setup lang="ts">
import { Exhibition, ExhibitionDates } from '@/types/exhibition.interface';
import { inject, ref } from 'vue';
import { MainMenu } from '@/types/global.interface';
import { useNavigation } from '@/composables/Common.js';

const emit = defineEmits({ close: null, isSamePath: false });

withDefaults(
  defineProps<{
    limit?: string;
    link?: string;
    title?: string;
  }>(),
  {
    limit: '3',
    link: 'Browse all exhibitions',
    title: 'Exhibitions on View',
  },
);

const mainMenu = inject<MainMenu>('mainMenu');

const { checkIsSamePath } = useNavigation();

const exhibitions = ref<Array<Exhibition>>([]);

if (mainMenu && mainMenu.exhibitions) {
  exhibitions.value = mainMenu.exhibitions;
}

function format(dates: ExhibitionDates): string {
  if (dates.label) {
    return dates.label;
  }

  return `Through ${dates.end.month} ${dates.end.day}, ${dates.end.year}`;
}
</script>

<style lang="scss">
@use '@/styles/links.module.scss' as *;
</style>

<style lang="scss" module>
.label {
  @include body-2;
  @include space-0-above;

  & {
    color: $black;
    display: block;
  }
}
.link {
  &:global(.more-link) {
    @include space-22-27-above;
  }
}
.list {
  margin: 2rem 0 0;
  padding: 0;

  li {
    list-style: none;
  }
}
</style>
